// 老师端-系统管理
import services from '../assets/js/services'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    // 获取用户列表
    getSchoolManageUser (context, payload) {
      return services.getSchoolManageUser(payload).then(res => {
        return res;
      })
    },
    // 用户添加
    addSchoolManageUser (context, payload) {
      return services.addSchoolManageUser(payload).then(res => {
        return res;
      })
    },
    //  用户编辑、删除
    editSchoolManageUser (context, payload) {
      return services.editSchoolManageUser(payload).then(res => {
        return res;
      })
    },
    //  用户详情
    getSchoolManageUserInfo (context, payload) {
      return services.getSchoolManageUserInfo(payload).then(res => {
        return res;
      })
    },
    //  用户查询
    getSchoolManageUserSearch (context, payload) {
      return services.getSchoolManageUserSearch(payload).then(res => {
        return res;
      })
    },
    //  学生列表
    getSchoolStudent (context, payload) {
      return services.getSchoolStudent(payload).then(res => {
        return res;
      })
    },
    //  学生重置密码
    resetSchoolStudentPassword (context, payload) {
      return services.resetSchoolStudentPassword(payload).then(res => {
        return res;
      })
    },
    //  学生添加
    addSchoolStudent (context, payload) {
      return services.addSchoolStudent(payload).then(res => {
        return res;
      })
    },
    //  学生编辑、删除
    editSchoolStudent (context, payload) {
      return services.editSchoolStudent(payload).then(res => {
        return res;
      })
    },
    //  学生详情
    getSchoolStudentInfo (context, payload) {
      return services.getSchoolStudentInfo(payload).then(res => {
        return res;
      })
    },
    // 学生查询
    getSchoolStudentSearch (context, payload) {
      return services.getSchoolStudentSearch(payload).then(res => {
        return res;
      })
    },
    // 学生导入2
    importSchoolStudent (context, payload) {
      return services.importSchoolStudent(payload).then(res => {
        return res;
      })
    },
    
  },
  mutations: {
  }
}